import { createSlice, type PayloadAction } from '@reduxjs/toolkit';

type ComparisonState = {
  selectedSkus: string[];
};

const initialState: ComparisonState = {
  selectedSkus: [],
};

const comparisonSlice = createSlice({
  name: 'comparison',
  initialState,
  reducers: {
    setComparisonSkus: (state, action: PayloadAction<string[]>) => {
      state.selectedSkus = action.payload;
    },
    addSkuToComparison: (state, action: PayloadAction<string>) => {
      if (!state.selectedSkus.includes(action.payload) && state.selectedSkus.length < 4) {
        state.selectedSkus.push(action.payload);
      }
    },
    removeSkuFromComparison: (state, action: PayloadAction<string>) => {
      state.selectedSkus = state.selectedSkus.filter(sku => sku !== action.payload);
    },
    clearComparison: (state) => {
      state.selectedSkus = [];
    },
  },
});

export const {
  setComparisonSkus,
  addSkuToComparison,
  removeSkuFromComparison,
  clearComparison,
} = comparisonSlice.actions;

export default comparisonSlice;
